@if (showPicker) {
  <div
    class="tw-fixed tw-inset-0 tw-bg-black tw-opacity-50 tw-z-10"
    (click)="showPicker = false"
  ></div>
}
<div class="tw-w-full tw-h-12 tw-flex tw-gap-2 tw-items-center" [appScrollLock]="isPickerOpen">
  <div
    class="tw-w-full tw-h-full tw-relative tw-bg-dt-surface-card tw-rounded-2xl"
    [ngClass]="showPicker ? 'tw-z-20' : ''"
  >
    <div
      #pickerTrigger
      class="tw-w-full tw-h-full tw-rounded-2xl tw-flex tw-gap-2 tw-whitespace-nowrap tw-items-center tw-px-6 xs:tw-px-4 tw-shadow-elevation-card hover:tw-bg-dt-surface-elevated tw-cursor-pointer border-gradient-neuomorphic hover-border-today"
      [ngClass]="{
        'tw-bg-dt-surface-elevated border-active-today !tw-shadow-none': showPicker,
      }"
      (click)="togglePicker()"
      appKeyboardActivatable
      aria-haspopup="dialog"
      [appKeyboardActivatableExpanded]="showPicker"
      (appKeyboardActivatableActivate)="togglePicker()"
    >
      <div class="tw-w-full tw-flex tw-items-center tw-justify-between tw-gap-2">
        <span>{{ displayDate() }}</span>
        <icon name="calendar" [size]="6" [currentColor]="'neutral-600'"></icon>
      </div>
    </div>
    <app-calendar
      #picker
      role="dialog"
      [attr.aria-label]="'date' | i18n"
      *ngIf="showPicker"
      [singleDate]="true"
      [confirmMode]="true"
      [timeDirectionOptions]="[AGO]"
      [selectedDate]="selectedDate()"
      [currentDateFilter]="dateFilter()"
      (dateSelected)="onDateSelected($event)"
      (cancelEvent)="closePicker()"
      class="date-picker today"
      [ngStyle]="{ transform: 'translateX(' + pickerTranslateValue + ')' }"
    ></app-calendar>
  </div>
</div>
